<div class="modal">
    <div class="modal__notification">
        <div class="modal__icon" *ngIf="data.category==='success'">
            <bc-icon size="3xl" name="successful" [ariaHidden]="false" ariaLabel="name"></bc-icon>
        </div>
        <div class="modal__icon" *ngIf="data.category==='failure'">
            <bc-icon size="3xl" name="remove" [ariaHidden]="false" ariaLabel="name"></bc-icon>
        </div>
        <div class="modal__icon" *ngIf="data.category==='question'">
            <bc-icon size="3xl" name="circle-question" [ariaHidden]="false" ariaLabel="name"></bc-icon>
        </div>
        <div class="modal__icon" *ngIf="data.category==='information'">
            <bc-icon size="3xl" name="information" [ariaHidden]="false" ariaLabel="name"></bc-icon>
        </div>
        <div class="modal__tittle">
            <h2>{{data.tittle}}</h2>
        </div>
        <div class="modal__description">
            <p>{{data.description}} </p>
        </div>
        <div class="modal__button"
            *ngIf="data.category==='success' || data.category==='failure' || data.category==='information'">
            <button bc-button class="modalClose" sizeButton="puffy" width="hug" typeButton="primary" (click)="close()">
                Cerrar
            </button>
        </div>
        <div class="bc-row bc-mb-5 bc-justify-content-center" *ngIf="data.category==='question'">
            <div class="bc-col-2 bc-block bc-justify-content-center">
                <button bc-button class="accionOperacionSi" sizeButton="puffy" width="fill" typeButton="primary"
                    (click)="aceptar()">
                    si
                </button>
            </div>
            <div class="bc-col-2 bc-block bc-justify-content-center">
                <button bc-button class="accionOperacionNo" sizeButton="puffy" width="fill" typeButton="primary"
                    (click)="denegar()">
                    no
                </button>
            </div>
        </div>
    </div>
</div>